module.exports = __webpack_public_path__ + "static/media/spacehey.c57dc317.svg";